<div class="container-fluid">
    <div class="row">

        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1" style="padding-left: 5px; padding-right: 5px;">
            <label>Codification:
                <!-- <span class="required_champs">*</span> -->
            </label>
            <input (input)="onChangeAnyThing()" class="form-control custom-input" [disabled]="itemToSave.id"
                placeholder="Codification" autocomplete="off" [(ngModel)]="itemToSave.codification" name="codification"
                autocomplete="off" type="text" />
        </div>

        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Libellé :
                <span class="required_champs">*</span>
            </label>
            <input (input)="onChangeAnyThing()" class="form-control custom-input" placeholder="Libellé"
                autocomplete="off" [(ngModel)]="itemToSave.libelle" name="libelle" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
            <label>Mode de reconduction :
            </label>
            <ng-select (change)="onChangeAnyThing()" [clearable]="true" [(ngModel)]="itemToSave.mode_reconduction_id"
                placeholder="Choisissez " name="mode_reconduction_id" id="mode_reconduction_id" [multiple]="false"
                [closeOnSelect]="true">
                <ng-option *ngFor="let item of itemsModeReconduction" [(value)]="item.id">{{
                    item?.libelle }}
                </ng-option>
            </ng-select>
        </div>


        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
            <label>Mode de fractionnement :
            </label>
            <ng-select (change)="onChangeAnyThing()" [clearable]="true" [(ngModel)]="itemToSave.mode_fractionnement_id"
                placeholder="Choisissez " name="mode_fractionnement_id" id="mode_fractionnement_id" [multiple]="false"
                [closeOnSelect]="true">
                <ng-option *ngFor="let item of itemsModeFractionnement" [(value)]="item.id">{{
                    item?.libelle }}
                </ng-option>
            </ng-select>
        </div>

        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Taux de couverture(%):
            </label>
            <br>
            <input (input)="onChangeAnyThing()" class="form-control custom-input"
                [(ngModel)]="itemToSave.taux_couverture" name="taux_couverture" autocomplete="off" type="text"
                mask="000" />
        </div>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label (click)="openModalPrestataireReseau()"
                [ngClass]="{'isSelectedItem':itemToSave.reseau_de_soin_id}">Réseau de soin :
            </label>

            <ng-select (change)="onChangeAnyThing()" [clearable]="true" [(ngModel)]="itemToSave.reseau_de_soin_id"
                placeholder="Choisissez " name="reseau_de_soin_id" id="reseau_de_soin_id" [multiple]="false"
                [closeOnSelect]="true">
                <ng-option *ngFor="let item of itemsReseauDeSoin" [(value)]="item.id">{{
                    item?.libelle }}
                </ng-option>
            </ng-select>

        </div>

        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Plafond par famille:
                <!-- <span class="required_champs">*</span> -->
            </label>
            <br>
            <input (input)="onChangeAnyThing()" class="form-control custom-input"
                [(ngModel)]="itemToSave.plafond_annuel_famille" name="plafond_annuel_famille" autocomplete="off"
                type="text" mask="separator" />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Description:
            </label>
            <textarea (input)="onChangeAnyThing()" class="form-control custom-input"
                [(ngModel)]="itemToSave.description" name="description" placeholder="Description" id="" cols="30"
                rows="2"></textarea>
        </div>

    </div>
</div>